import React from 'react';
import { Badge, Button, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import useMobile from 'services/Hooks/useMobile';
import { useApprovalNotification } from 'services/Data/NotificationService';
import { useSelector } from 'react-redux';
import { getDealerPortalHeaderButtonSx, getDealerPortalStateDisplay } from 'services/Utilities/dealerPortalStateUtils';

const AccountButton = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const accountReducer = useSelector(state => state.AccountReducer);
  const portalStateDisplay = getDealerPortalStateDisplay(t);
  const buttonSx = getDealerPortalHeaderButtonSx(theme, portalStateDisplay.isNonProduction);

  const { data: notification } = useApprovalNotification(accountReducer.isLoggedIn);
  const isMobile = useMobile();

  return (
    <React.Fragment>
      <Badge
        badgeContent={
          notification?.cartsNeedApproval || notification?.exteriorSignageNeedApproval
            ? notification?.cartsNeedApproval + notification?.exteriorSignageNeedApproval
            : null
        }
        color="error">
        <Button
          className={'toto'}
          variant="contained"
          sx={buttonSx}
          endIcon={<ApplicationIcons.Users />}
          component={NavLink}
          to={'/dealer/profile'}>
          <Typography variant="h4">{isMobile ? '' : t('account')}</Typography>
        </Button>
      </Badge>
    </React.Fragment>
  );
};

export default AccountButton;
